export default __webpack_public_path__ + "static/media/doelen_halen.50a6b2cd.jpg";